import { isEmpty } from '@jfs/ui-new/src/utils/utils'
import { isEmptyObject } from '@jfs/utils'
import { getTime } from '../../util/util'

export const CampaignDetailsParser = (data: any, metaInfo: any) => {
  const getValueMetaInfo = (key: any, type: string) => {
    const arr = key?.toString()?.split('|')
    const retData: any = []
    const values = metaInfo.filter((item: any) => type === item.type)?.[0]?.values
    arr?.map((arrItem: any) => {
      const retItem = values?.find((item: any) => item?.id === Number(arrItem))?.value ?? ''
      if (!isEmpty(retItem)) {
        retData.push(retItem)
      }
    })
    return retData?.toString() ?? ''
  }

  const getTenureValues = (emi: any) => {
    return emi?.map((item: any) => {
      return item?.tenure ?? ''
    })
  }

  const getROI = (emi: any) => {
    const retData = []
    emi?.map((item: any) => {
      item?.rate > 0 && retData?.push(`${item?.rate ?? ''}`)
    }) ?? []
    return retData
  }

  const getPurchaseType = (types: any) => {
    const retItem = `${types?.[0] === 110}|${types?.[1] === 114}`
    return retItem
  }

  const getProducts = (data: any) => {
    if (!!data && !isEmptyObject(data)) {
      const keys = Object.keys(data)
      let count = 0
      if (keys.includes('productid_included') || keys.includes('productid_excluded')) {
        count = count + 1
        keys.push('txnAttributeKey' + count)
        data[`txnAttributeKey${count}`] = 'Product Id'
        data[`txnAttributeIncluded${count}`] = data?.productid_included?.split('|')
        data[`txnAttributeExcluded${count}`] = data?.productid_excluded?.split('|')
      }
      if (keys.includes('category1_included') || keys.includes('category1_excluded')) {
        count = count + 1
        keys.push('txnAttributeKey' + count)
        data[`txnAttributeKey${count}`] = 'Category Id - 1'
        data[`txnAttributeIncluded${count}`] = data?.category1_included?.split('|')
        data[`txnAttributeExcluded${count}`] = data?.category1_excluded?.split('|')
      }
      if (keys.includes('category2_included') || keys.includes('category2_excluded')) {
        count = count + 1
        keys.push('txnAttributeKey' + count)
        data[`txnAttributeKey${count}`] = 'Category Id - 2'
        data[`txnAttributeIncluded${count}`] = data?.category2_included?.split('|')
        data[`txnAttributeExcluded${count}`] = data?.category2_excluded?.split('|')
      }
      if (keys.includes('category3_included') || keys.includes('category3_excluded')) {
        count = count + 1
        keys.push('txnAttributeKey' + count)
        data[`txnAttributeKey${count}`] = 'Category Id - 3'
        data[`txnAttributeIncluded${count}`] = data?.category3_included?.split('|')
        data[`txnAttributeExcluded${count}`] = data?.category3_excluded?.split('|')
      }
      if (keys.includes('category4_included') || keys.includes('category4_excluded')) {
        count = count + 1
        keys.push('txnAttributeKey' + count)
        data[`txnAttributeKey${count}`] = 'Category Id - 4'
        data[`txnAttributeIncluded${count}`] = data?.category4_included?.split('|')
        data[`txnAttributeExcluded${count}`] = data?.category4_excluded?.split('|')
      }
      if (keys.includes('category5_included') || keys.includes('category5_excluded')) {
        count = count + 1
        keys.push('txnAttributeKey' + count)
        data[`txnAttributeKey${count}`] = 'Category Id - 5'
        data[`txnAttributeIncluded${count}`] = data?.category5_included?.split('|')
        data[`txnAttributeExcluded${count}`] = data?.category5_excluded?.split('|')
      }
      return data
    }
  }

  const getBankNames = (emiData: any) => {
    const retData = emiData?.map((item) => {
      return getValueMetaInfo(item?.bankEmiId, 'bankEmiId')
    })
    return retData
  }
  const retData = {
    cId: data?.offer?.offerCode,
    title: data?.offer?.offerName,
    description: data?.offer?.offerDescription,
    maxBudget: data?.offer?.maxOfferDiscount ?? 0,
    offerMaxCount: data?.method?.values?.maxDiscount,
    startDate: data?.offer?.startDate,
    endDate: data?.offer?.endDate,
    startTime: data?.offer?.startTime,
    endTime: data?.offer?.endTime,
    startTimestamp: getTime(data?.offer?.startDate, data?.offer?.startTime),
    endTimestamp: getTime(data?.offer?.endDate, data?.offer?.endTime),
    status: getValueMetaInfo(data?.offer?.status, 'status') ?? 'NA',
    tnc: data?.offer?.termsConditions,
    txnAmountRange:
      data?.offer?.maxOrderAmount && data?.offer?.minOrderAmount
        ? `₹${data?.offer?.minOrderAmount} - ₹${data?.offer?.maxOrderAmount}`
        : data?.offer?.maxOrderAmount
        ? `<${data?.offer?.maxOrderAmount}`
        : `>${data?.offer?.minOrderAmount}`,
    paymentModes: data?.method?.subType ?? 0,
    cardTypes: getValueMetaInfo(data?.method?.values?.cardScheme, 'Card') ?? '',
    purchaseTypes: data?.method?.type?.join(','),
    emiBankName: getBankNames(data?.method?.values?.emi),
    emiTenure: getTenureValues(data?.method?.values?.emi),
    roi: getROI(data?.method?.values?.emi),
    bankIds:
      getValueMetaInfo(data?.method?.values.bankId ?? '', data?.method?.subType === 579 ? 'Wallet' : 'Bank') ?? '',
    bins: data?.method?.values?.bins?.split('|'),
    // rewards
    discount: getValueMetaInfo(data?.offer?.offerType, 'rewardType') ?? 'NA',
    discountType: getValueMetaInfo(data?.offer?.unitType, 'unitType') ?? 'NA',
    value: data?.offer?.unitValue ?? 0,
    issueFrequency: data?.issueFrequency ?? '',
    issueCountPerUser: data?.method?.values?.maxCount ?? 0,
    combinedWith: data?.offer?.combinedWith,
    //product
    products: getProducts(data?.product) ?? {},
  }
  return retData
}
